import React, {Component} from 'react';
import {connect} from 'react-redux';
import firebase from 'firebase/app';
import 'firebase/database';
import {createStructuredSelector} from 'reselect';
import {withRouter} from 'react-router-dom';
import {firebaseRef, config} from '../Configs/Firebase';
import {clearCustomer} from '../Pages/Customer/actions';
import {
  makeSelectHotel,
  makeSelectToken,
} from '../Pages/Authentication/selectors';
import {QzCertificate} from '../Configs/QZTray';
import {checkIfObjectEmpty} from '../Libs/object';
import IncomingCall from './IncomingCall';

firebase.initializeApp(config);

class Firebase extends Component {
  constructor(props) {
    super(props);
    this.state = {
      calls: [],
    };
  }

  componentDidMount() {
    const {
      token,
      hotel: {branch},
    } = this.props;
    QzCertificate(token);

    this.unsubscribe = firebase
      .database()
      .ref(firebaseRef)
      .on('child_changed', (snapshot) => {
        if (!checkIfObjectEmpty(snapshot)) {
          const response = snapshot.val();
          if (
            !checkIfObjectEmpty(response) &&
            response.branch_id === branch.id
          ) {
            this.addCall(response);
          }
        }
      });
    this.unsubscribe1 = firebase
      .database()
      .ref(firebaseRef)
      .on('child_added', (snapshot) => {
        if (!checkIfObjectEmpty(snapshot)) {
          const response = snapshot.val();
          if (
            !checkIfObjectEmpty(response) &&
            response.branch_id === branch.id
          ) {
            this.addCall(response);
          }
        }
      });
  }

  onProcessCall = (call, status) => {
    // const {onClearCustomer} = this.props;
    firebase
      .database()
      .ref(`${firebaseRef}/${call.from}`)
      .set({
        ...call,
        status,
      });
    // onClearCustomer();
  };

  componentWillUnmount() {
    this.unsubscribe();
    this.unsubscribe1();
  }

  addCall = (response) => {
    const {calls} = this.state;
    const index = calls.findIndex((call) => call.from === response.from);
    if (index === -1) {
      this.setState({
        calls: [...calls, response],
      });
    } else {
      this.setState({
        calls: calls.map((call) => {
          if (call.from === response.from) {
            return response;
          }
          return call;
        }),
      });
    }
  };

  render() {
    const {calls} = this.state;
    return (
      <div className="incoming-calls">
        {calls.map((call) => (
          <IncomingCall
            key={call.unique_call_id}
            call={call}
            onProcessCall={this.onProcessCall}
          />
        ))}
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  onClearCustomer: () => dispatch(clearCustomer()),
});

const mapStateToProps = createStructuredSelector({
  token: makeSelectToken(),
  hotel: makeSelectHotel(),
});
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(Firebase));
